module.exports = __webpack_public_path__ + "static/media/rss-interface.6e84fbfd.svg";